"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterPage = void 0;
var BaseEntity_1 = require("../../../models/concrete/BaseEntity");
;
var FilterPage = /** @class */ (function (_super) {
    __extends(FilterPage, _super);
    function FilterPage(data) {
        var _this = _super.call(this, data) || this;
        _this.title = data.title;
        _this.altTitle = data.alt_title;
        _this.text = data.text;
        _this.slug = data.slug;
        _this.imageId = data.image_id;
        _this.searchData = data.search_data;
        _this.bottomText = data.bottom_text;
        _this.yandexCollectionId = data.yandex_collection_id;
        _this.categoryId = data.category_id;
        _this.url = data.url;
        return _this;
    }
    return FilterPage;
}(BaseEntity_1.BaseEntity));
exports.FilterPage = FilterPage;
//# sourceMappingURL=FilterPage.js.map